import { Box, Stack } from '@mui/material';
import { MprcMessageBox } from 'components/MprcMessageBox';
import { MprcSpinnerIndicator } from 'components/MprcSpinnerIndicator';
import { useEffect, useRef, useState } from 'react';
import { SessionService } from 'services/sessionService';

interface IProps {
    assetId: string;
}

export const MprcHtmlViewer = ({ assetId }: IProps) => {
    const [error, setError] = useState<any>(null);
    const viewerRef = useRef<HTMLIFrameElement>(null);
    const toolbarRef = useRef<HTMLDivElement>(null);

    const apiUrl = SessionService.current.apiPaths.coreApi;

    useEffect(() => {
        async function init() {
            try {
                const res = await fetch(`${apiUrl}/GetAsset/${assetId}`);

                if (!res.ok) throw new Error(`HTTP ${res.status}`);

                const contentType = res.headers.get('Content-Type') ?? 'text/html';
                const blob = await res.blob();
                const blobUrl = URL.createObjectURL(
                    new Blob([blob], { type: contentType })
                );

                // Libera memória quando o iframe descarregar
                viewerRef.current!.onload = () => {
                    URL.revokeObjectURL(blobUrl);
                };

                viewerRef.current!.src = blobUrl;
                viewerRef.current!.style.display = 'block';
                toolbarRef.current!.style.display = 'none';
            } catch (err) {
                setError(err);
            }
        }

        if (viewerRef.current) init();

    }, [viewerRef]);

    return (
        error
            ? <Stack justifyContent="center" alignItems="center" sx={{ height: "100%", margin: 4 }}>
                <MprcMessageBox
                    fullWidth
                    variant='error'
                    message={
                        <>
                            <b>{error.message}</b>
                        </>
                    }
                />
            </Stack>
            : <>
                <Box id="toolbar" ref={toolbarRef} sx={{ height: "100%" }}>
                    <Stack alignItems={"center"} justifyContent={"center"} sx={{ height: "100%" }}>
                        <MprcSpinnerIndicator />
                    </Stack>
                </Box>
                <iframe
                    id="viewer"
                    ref={viewerRef}
                    title='Html Viewer'
                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts"
                    style={{ width: "100%", height: "100%", border: 0, margin: 0, padding: 0, display: "none" }}></iframe>
            </>

    );
};